<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title' v-if="isRouteAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouteAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouteAlive = false
      this.$nextTick (() => {
        this.isRouteAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}

body {
  overflow: scroll;
  overflow-y:hidden;
  overflow-x:hidden
}
</style>
